<div class="app-select">
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <mat-select
      (selectionChange)="onSelection($event)"
      [(value)]="selectedValue"
    >
      @if (defaultOption) {
        <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
      }
      @for (option of options; track $index) {
        <mat-option [value]="option.value">{{ option.text }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
